module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/ClanQuestsTutorial/images/slide-2-image.f680684d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/ClanQuestsTutorial/images/slide-2-image.png
// module id = 2934
// module chunks = 11